<script setup lang="ts">
import {Drawer} from "@/Components/Library";
import {AiChats} from "@/Components/Global";

const visible = defineModel<boolean>("visible");
const {
    question,
    selectedGroups = [],
    dateFrom = null,
    dateTo = null,
} = defineProps<{
    question: {id: string} | null;
    selectedGroups?: any[];
    dateFrom?: string | null;
    dateTo?: string | null;
}>();
</script>
<template>
    <Drawer
        v-model:visible="visible"
        position="right"
        header="Analyze Post Responses"
        :closable="true"
        class="w-full max-w-7xl border-l-[1.4rem] !border-l-askr-green-500 !shadow-2xl !shadow-black"
        :modal="false"
    >
        <AiChats
            v-if="question?.id"
            parent-type="question"
            :parent-id="question.id"
            :params="{
                selectedGroups: selectedGroups,
                dateFrom: dateFrom,
                dateTo: dateTo,
            }"
        />
    </Drawer>
</template>
<style scoped></style>
